module.exports = __webpack_public_path__ + "img/code.5c54cfdc.png";